import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = axios.create({ baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api' });

const STATUS_LABELS = {
  trial: 'Trial', recipe_confirmed: 'Recipe Confirmed',
  commercial_trial: 'Commercial Trial', launched: 'Launched',
};
const STATUS_COLORS = {
  trial: '#e67e00', recipe_confirmed: '#2e7d32',
  commercial_trial: '#1a56db', launched: '#7B2D6B',
};
const STATUS_BG = {
  trial: '#fff3e0', recipe_confirmed: '#f0faf0',
  commercial_trial: '#e8f0fe', launched: '#f3e8ff',
};

export default function ProjectSummary({ project }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get(`/projects/${project.id}/summary-report`).then(r => setData(r.data));
  }, [project.id]);

  const printPDF = () => {
    if (!data) return;
    const today = new Date().toLocaleDateString('en-AE', { day: '2-digit', month: 'short', year: 'numeric' });
    const userName = (() => { try { const u = JSON.parse(localStorage.getItem('npd_user')); return u?.name || u?.username || ''; } catch { return ''; } })();

    const rows = data.products.map((p, idx) => `
      <tr style="${idx%2===1?'background:#fdf9fc;':''}">
        <td style="font-family:'Courier New',monospace;font-size:9px;color:#7B2D6B;font-weight:600;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${p.product_code}</td>
        <td style="font-size:10px;font-weight:500;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${p.name}</td>
        <td style="padding:5px 8px;border-bottom:0.5px solid #f5edf3;text-align:center;">
          <span style="display:inline-block;padding:1px 8px;border-radius:20px;font-size:8px;font-weight:600;background:${STATUS_BG[p.status]||'#f5f5f5'};color:${STATUS_COLORS[p.status]||'#555'}">${STATUS_LABELS[p.status]||p.status}</span>
        </td>
        <td style="font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;color:#888;">${p.department||'—'}</td>
        <td style="font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;color:#888;font-family:monospace;">${p.internal_group||'—'}</td>
        <td style="font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;color:#888;">${p.product_type||'—'}</td>
      </tr>`).join('');

    const statusSummary = Object.entries(
      data.products.reduce((acc, p) => { acc[p.status] = (acc[p.status]||0)+1; return acc; }, {})
    ).map(([s, c]) => `<div style="text-align:center;padding:8px 14px;border-right:1px solid #e4d4e0;">
      <div style="font-size:7px;letter-spacing:0.14em;text-transform:uppercase;color:#c0a0b8;margin-bottom:3px;">${STATUS_LABELS[s]||s}</div>
      <div style="font-size:16px;font-weight:700;color:${STATUS_COLORS[s]||'#333'};">${c}</div>
    </div>`).join('');

    const win = window.open('', '_blank');
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
    <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
    <style>
      *{box-sizing:border-box;margin:0;padding:0;}
      body{font-family:'Inter',Arial,sans-serif;background:#fff;padding:28px;color:#1a1a1a;font-size:11px;}
      .top-bar{height:4px;background:linear-gradient(90deg,#7B2D6B 0%,#a03880 55%,#E8541A 100%);border-radius:2px 2px 0 0;}
      .bottom-bar{height:4px;background:linear-gradient(90deg,#7B2D6B 0%,#a03880 55%,#E8541A 100%);border-radius:0 0 2px 2px;margin-top:12px;}
      table{width:100%;border-collapse:collapse;}
      th{padding:5px 8px;text-align:left;font-size:7px;letter-spacing:0.1em;text-transform:uppercase;color:#c0a0b8;font-weight:600;border-bottom:1px solid #e4d4e0;}
      @media print{body{padding:16px;} @page{margin:0;size:A4;} body{padding:20px 28px;}}
    </style></head><body>
    <div class="top-bar"></div>
    <div style="padding:12px 0 10px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #f0e8ed;margin-bottom:12px;">
      <div>
        <div style="font-size:6.5px;letter-spacing:0.22em;text-transform:uppercase;color:#E8541A;margin-bottom:3px;">Project Summary Report</div>
        <div style="font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#7B2D6B;">Kallada Food Industries LLC</div>
        <div style="font-size:8px;color:#c0a0b8;margin-top:1px;">Dubai, United Arab Emirates</div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:26px;font-weight:800;color:#7B2D6B;letter-spacing:-0.02em;position:relative;display:inline-block;">BGH<span style="position:absolute;top:1px;right:-9px;width:7px;height:7px;background:#E8541A;border-radius:1.5px;display:inline-block;"></span></div>
        <div style="font-size:6px;letter-spacing:0.16em;text-transform:uppercase;color:#E8541A;font-weight:600;margin-top:3px;">Bettergrow Holding</div>
      </div>
    </div>
    <div style="background:#f9f3f8;border:1px solid #ede0ea;border-radius:3px;padding:8px 14px;margin-bottom:14px;">
      <div style="font-size:14px;font-weight:700;color:#7B2D6B;margin-bottom:6px;">${data.project.name}</div>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:12px;">
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Code</div><div style="font-family:monospace;font-size:10px;font-weight:600;color:#555;">${data.project.project_code}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Department</div><div style="font-size:10px;font-weight:600;color:#333;">${data.project.department||'—'}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Start Date</div><div style="font-size:10px;font-weight:600;color:#333;">${data.project.start_date||'—'}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">End Date</div><div style="font-size:10px;font-weight:600;color:#333;">${data.project.end_date||'—'}</div></div>
      </div>
    </div>
    <div style="display:flex;border:1px solid #e4d4e0;border-radius:4px;overflow:hidden;margin-bottom:14px;">
      <div style="padding:8px 14px;background:#f9f3f8;border-right:1px solid #e4d4e0;text-align:center;">
        <div style="font-size:7px;letter-spacing:0.14em;text-transform:uppercase;color:#c0a0b8;margin-bottom:3px;">Total Products</div>
        <div style="font-size:20px;font-weight:700;color:#7B2D6B;">${data.products.length}</div>
      </div>
      ${statusSummary}
    </div>
    <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
      <div style="width:3px;height:14px;background:#7B2D6B;border-radius:2px;"></div>
      <div style="font-size:7px;letter-spacing:0.2em;text-transform:uppercase;font-weight:700;color:#7B2D6B;">Product List</div>
      <div style="flex:1;height:1px;background:#7B2D6B;opacity:0.18;"></div>
    </div>
    <table>
      <thead><tr>
        <th style="width:85px;">Code</th>
        <th>Product Name</th>
        <th style="width:110px;text-align:center;">Status</th>
        <th style="width:90px;">Department</th>
        <th style="width:80px;">Group</th>
        <th style="width:80px;">Type</th>
      </tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div style="margin-top:14px;display:grid;grid-template-columns:1fr 1fr 1fr;border:1px solid #e4d4e0;border-radius:3px;overflow:hidden;">
      <div style="padding:8px 12px;border-right:1px solid #e4d4e0;">
        <div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.14em;margin-bottom:3px;">Prepared By</div>
        <div style="font-size:10px;font-weight:600;color:#333;">${userName}</div>
      </div>
      <div style="padding:8px 12px;border-right:1px solid #e4d4e0;">
        <div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.14em;margin-bottom:3px;">Project Status</div>
        <div style="font-size:10px;font-weight:600;color:#333;">${data.project.status}</div>
      </div>
      <div style="padding:8px 12px;background:#7B2D6B;">
        <div style="font-size:7px;color:rgba(255,255,255,0.6);text-transform:uppercase;letter-spacing:0.14em;margin-bottom:3px;">Report Date</div>
        <div style="font-size:10px;font-weight:700;color:#fff;">${today}</div>
      </div>
    </div>
    <div style="margin-top:10px;text-align:center;">
      <span style="font-size:7px;color:#d0bfca;letter-spacing:0.07em;text-transform:uppercase;">Kallada Food Industries LLC · Confidential Document · ${today}</span>
    </div>
    <div class="bottom-bar"></div>
    </body></html>`);
    win.document.close();
    win.focus();
  };

  if (!data) return <div className="empty-state"><p>Loading...</p></div>;

  const statusCount = data.products.reduce((acc, p) => { acc[p.status] = (acc[p.status]||0)+1; return acc; }, {});

  return (
    <div>
      <div className="flex-between mb-6">
        <div className="text-muted" style={{ fontSize: 13 }}>{data.products.length} products in this project</div>
        <button className="btn btn-primary" onClick={printPDF}>⬇ Download / Print PDF</button>
      </div>

      <div className="stats-grid mb-6">
        {['trial','recipe_confirmed','commercial_trial','launched'].map(s => (
          <div key={s} className="stat-card">
            <div className="stat-label">{STATUS_LABELS[s]}</div>
            <div className="stat-value">{statusCount[s]||0}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-title">Product List</div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>Code</th><th>Product Name</th><th>Status</th><th>Department</th><th>Group</th><th>Type</th></tr>
            </thead>
            <tbody>
              {data.products.map(p => (
                <tr key={p.product_code}>
                  <td className="mono">{p.product_code}</td>
                  <td style={{ fontWeight: 500 }}>{p.name}</td>
                  <td><span style={{ display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:10, fontWeight:600, background:STATUS_BG[p.status]||'#f5f5f5', color:STATUS_COLORS[p.status]||'#555' }}>{STATUS_LABELS[p.status]||p.status}</span></td>
                  <td className="text-muted">{p.department||'—'}</td>
                  <td className="mono">{p.internal_group||'—'}</td>
                  <td className="text-muted">{p.product_type||'—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
